import Vue from 'vue';

var translationService = function () {
  var _TranslationsDictionary = {};

  var _init = () => {
    var headers = {};
    headers.PwaEnableCache = 1;

    var data = {
      'currentCultureName' : window.pwa_currentCultureName
    }

    $.ajax('/umbraco/vwa/AsyncSurface/GetVueDictionary/', { type: 'GET', headers: headers, data: data, success: success, error: error });

    function success(data) {
      JSON.parse(data).forEach(e => Vue.set(_TranslationsDictionary, e.key , e.value));
    }
    function error() { }
  };

  _init();

    return {
        TranslationsDictionary: _TranslationsDictionary,

        getTranslation: function (key, fallback) {
          var value = this.TranslationsDictionary[key];
          if (!value) {
              return fallback ? fallback :  key;
          }
          return value;
      }
  }
}();

export default translationService;



// WEBPACK FOOTER //
// ./Vue/Src/Services/TranslateService.js